import React from 'react';
import {
    View,
    Text,
    StyleSheet
} from 'react-native';

const RankingListComponent = ({ userName, userPoints, rankingPosition }) => {

    return(
        <View style={styles.componentStyle}>
            <View style={styles.rankingIndicationContainerStyle}>
                <Text style={styles.rankingIndicationTextStyle}>
                    {rankingPosition + 'º'}
                </Text>
            </View>

            <View style={styles.userInformationContainerStyle}>
                <View style={{ width: '60%' }}>
                    <Text style={styles.userNameStyle}>
                        {userName}
                    </Text>
                </View>
                <View style={{width: '40%'}}>
                    <Text style={styles.userPointsStyle}>
                        {`${Math.round(userPoints * 100) / 100} Pontos`}
                    </Text>
                </View>
            </View>


        </View>
    )
};

const styles = StyleSheet.create({
    componentStyle: {
        margin: 3,
        width: '90%',
        height: 60,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    rankingIndicationContainerStyle: {
        marginRight: 2,
        width: '15%',
        height: '90%',
		borderRadius: 6,
		margin: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#606060'
    },
    rankingIndicationTextStyle: {
        fontSize: 28,
        textAlign: 'center',
        alignSelf: 'center',
        fontWeight: 'bold',
        color: 'white'
    },
    userInformationContainerStyle: {
        marginLeft: 2,
        width: '82%',
        height: '90%',
        backgroundColor: '#606060',
		borderRadius: 6,
		margin: 0,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    userNameStyle: {
        margin: 4,
        fontSize: 14,
        color: 'white',
        flexWrap: 'wrap'
    },
    userPointsStyle: {
        margin: 4,
        fontSize: 14,
		color: 'white',
		fontWeight: 'bold',
    }
});

export default RankingListComponent;
